import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pointToUnderscore',
    standalone: false
})
export class PointToUnderscorePipe implements PipeTransform {

  transform(value: any): any {
    return value.replace(/\./g, '_');
  }

}
